import { render, staticRenderFns } from "./RecordCategoryAnswersBox.vue?vue&type=template&id=1a297a7c"
import script from "./RecordCategoryAnswersBox.vue?vue&type=script&lang=ts"
export * from "./RecordCategoryAnswersBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports